import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UUID } from 'angular2-uuid';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { FormBuilderUDFService } from 'src/app/services/form-builder-udf-service';
@Component({
  selector: 'app-dropdown-property',
  templateUrl: './dropdown-property.component.html',
  styleUrls: ['./dropdown-property.component.scss']
})
export class DropdownPropertyComponent implements OnInit {
  private _attributes: any;
  public varcharAttributes: Array<any> = [];
  datasource:string;
  @Input() component: any;
  @Input() set attributes(value: any) {
    this._attributes = value;

    if (this._attributes) {
      this.varcharAttributes = _.sortBy(
        this._attributes.filter((att: any) => {
          return att.type === 'varchar';
        }),
        ['name']
      );
    }
  }

  get attributes(): any {
    return this._attributes;
  }

  @Output() onBindVariableChange: EventEmitter<any> = new EventEmitter();
  apiList: any;
  apiEndpoint
  filteredAPIS: any;
  constructor(private translate: TranslateService,private formService: FormBuilderUDFService,private toaster: ToastrService) {}

  ngOnInit() {
    this.getAPIList();
  }

  setAsDefault($event: any) {
    this.component.element.options.forEach((v: any, k: number) => {
      if (v.id == $event.target.value) {
        v.is_selected = true;
      } else {
        v.is_selected = false;
      }
    });
  }

  addOption() {
    this.component.element.options.push({
      id: UUID.UUID(),
      text: this.translate.instant('Option') + ' ' + (this.component.element.options.length + 1),
      value: this.translate.instant('Value') + ' ' + (this.component.element.options.length + 1),
      is_selected: false
    });
  }

  removeOption(optionId: any) {
    this.component.element.options = this.component.element.options.filter((v: any) => {
      return v.id != optionId;
    });
  }

  handleOnBindVariableChange($event: any) {
    this.onBindVariableChange.emit({
      value: $event,
      id: this.component.id
    });
  }

  onChangeDatasourcetype(selected:any){
    this.datasource = selected.value;
    if(this.datasource === 'url') {
      this.getAPIList();
    }
  }

  onChangeAPI(apiId: any) {   
    const APIDetails = this.apiList.find((api: any) => api.id === apiId);
    if (APIDetails) {
      this.component.element.requestType = APIDetails ? APIDetails.APIRequestType : '';
    this.component.element.datasourceUrl = APIDetails ? APIDetails.APIURL : '';
    this.component.element.datasourceParamaters = APIDetails ? APIDetails.APIPayloadParameter : '';
    this.component.element.resultsetfieldName = APIDetails ? APIDetails.APIResponseColumns : '';
    this.component.element.resultsetName = APIDetails ? APIDetails.APIResponseResultSetName : '';
    }
   
  }

  getAPIList() {
    this.formService.getAPIList().subscribe({
      next: (data: any) => {
      if (data) {
        this.apiList = data.Table;
        this.filteredAPIS = this.apiList.slice();
      }
      },
      error: (error: any) => {
      this.toaster.error('Error fetching API list');
      }
    });
  }

  onLabelChange(label: string) {
    // Update field name: convert to lowercase, replace spaces/special chars with underscores
    this.component.element.field_name = label
      ? label.toLowerCase()
          .replace(/[^a-z0-9]+/g, '_')  // Replace non-alphanumeric chars with underscore
          .replace(/^_+|_+$/g, '')       // Remove leading/trailing underscores
          .replace(/_+/g, '_')           // Replace multiple underscores with single
          .substring(0, 100)             // Limit to 100 characters
      : '';
  }
}
